import { ArticleMasterDataModel, ArticleMasterDataResultModel, ArticleStateModel } from "@/types/ContentEditor/content-editor-articles";
import { MTicket, ValidationFeedbackEntry } from "@/types/common/common";
import { CatalogNodeMasterData } from "@medapro-types/ContentEditor/content-editor-store";
import { AxiosError } from "axios";

export abstract class Typeguards {
  public static isRecord(e: unknown): e is Record<string, unknown> {
    return typeof e === "object" && e !== null;
  }
  public static isAxiosError(e: unknown): e is AxiosError {
    return !!e && (Object.hasOwn(e, "request") || Object.hasOwn(e, "response") || Object.hasOwn(e, "code"));
  }
  public static isMTicket(e: unknown): e is MTicket {
    return !!e && Object.hasOwn(e, "user") && Object.hasOwn(e, "token");
  }
  public static isSingleValidationFeedbackEntry(e: unknown): e is ValidationFeedbackEntry {
    return !!e && !Array.isArray(e) && Object.hasOwn(e, "feedback");
  }
  public static isArrayOfValidationFeedbackEntry(e: unknown): e is Array<Record<string, ValidationFeedbackEntry>> {
    return !!e && Array.isArray(e);
  }
  public static isArticleMasterData(e: unknown): e is ArticleMasterDataModel {
    return !!e && Object.hasOwn(e, "articleNo");
  }
  public static isArticleMasterDataResultModel(e: unknown): e is ArticleMasterDataResultModel {
    return !!e && Object.hasOwn(e, "articleId") && Object.hasOwn(e, "articleStateId") && Object.hasOwn(e, "rootCatalogNode");
  }
  public static isArticleStateModel(e: unknown): e is ArticleStateModel {
    return !!e && Object.hasOwn(e, "articleStateId") && Object.hasOwn(e, "name") && Object.hasOwn(e, "description");
  }
  public static isCatalogNodeMasterData(e: unknown): e is CatalogNodeMasterData {
    return (
      !!e && Object.hasOwn(e, "description") && Object.hasOwn(e, "catalogNodeType") && Object.hasOwn(e, "catalogNodeId") && Object.hasOwn(e, "rootCatalogNode")
    );
  }
  public static hasShowFunction(e: unknown): e is { show: () => void } {
    return !!e && Object.hasOwn(e, "show");
  }
}
